import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withIntl from '../../../../components/Intl/WithIntl';
import { Container, Row, Col, Card, CardHeader, CardTitle, CardBody, CardImg, CardImgOverlay, Jumbotron, ButtonGroup, Button, Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Error404Page(props) {
    return (
        <Container>
            <Row>
                <Col sm={{ size: 10, offset: 1 }} lg={{ size: 8, offset: 2 }}>
                    <Card className="shadow text-center">
                        <CardHeader>
                            <CardTitle>
                                <FontAwesomeIcon icon="exclamation-triangle" /> <FormattedMessage id="app404ErrorTitle" defaultMessage="Wrong Way..." />
                            </CardTitle>
                        </CardHeader>
                        <CardBody>
                            <ButtonGroup>
                                <Button href="/" tag="a" color="primary"><FontAwesomeIcon icon="chevron-left" /> <FormattedMessage id="back" defaultMessage="Back" /></Button>
                                <Button href="/user/profile" tag="a" color="info" outline><FontAwesomeIcon icon="tachometer-alt" /> <FormattedMessage id="userAccountMy" defaultMessage="My account" /></Button>
                            </ButtonGroup>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default withIntl(Error404Page);
